import React from "react";
import { Box, Switch, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const DefaultSwitch = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Default Switches
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The TextField wrapper component is a complete form control including a
          label, input, and help text. It comes with three variants: outlined
          (default), filled, and standard.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Default switch. default checked, unchecked, checked disable, disable"}
          language={"js"}
          value={
            '         <Switch defaultChecked />\n' +
            '          <Switch />\n' +
            '          <Switch disabled defaultChecked />\n' +
            '          <Switch disabled />'
          }
        >
          <Switch defaultChecked />
          <Switch />
          <Switch disabled defaultChecked />
          <Switch disabled />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default DefaultSwitch;
